<template>
    <div class="container">
        <div class="profile-container mt-10" v-if="profile">
            <div class="profile-image">
                <div class="profile-picture">
                    <span v-if="escort_data.profilepic == null" class="select-profile">
                        <img src="../assets/no_image.png" class="large-profile-pic" alt="" width="140px" height="140px" style="border-radius: 50%;">
                    </span>
                    <span v-else class="select-profile">
                        <img :src="escort_data.profilepic" 
                        class="large-profile-pic" alt="" 
                        width="140px" height="140px" 
                        style="border-radius: 50%; cursor: pointer;"
                        @click="selectedImage = escort_data.profilepic; showImageDialog = true"
                        >
                        <div class="d-flex likes-followers">
                            <h4 class="badge badge-info">{{ countLikes }} likes</h4> &nbsp;
                            <h4 class="badge badge-primary">{{ countFollowers }} followers</h4>
                        </div>
                    </span>
                    
                </div>
                <div class="profile-info mt-2">
                    <h3>{{ escort_data.username }} ({{ escort_data.age }})
                        <span v-if="escort_data.activation_paid == 1" class="verified-icon" title="Verified">
                            <i class="fa fa-check-circle text-success"></i>
                        </span>
                    </h3>
                    <p>{{ escort_data.location }} {{ escort_data.state }} | {{ escort_data.gender }} | <i class="fa fa-phone"></i>
                        <span v-if="escort_data.activation_paid == 1 || new Date(escort_data.trial_ends_at) > new Date()">
                        {{ escort_data.phone_number }}
                    </span>
                    <span v-else>
                        ***********
                    </span>
                    </p>
                    <hr class="mobile-line">
                    <p>{{ escort_data.bio }} </p>
                   

                    
                </div>
            </div>
          
        </div>
        <div class="bio-tab">
                <!-- Nav Tabs -->
                <ul class="nav nav-tabs mb-3" role="tablist">
                    <li class="nav-item" v-for="(tab, index) in tabs" :key="index">
                    <a
                        class="nav-link"
                        :class="{ active: activeTab === tab.name }"
                        @click="activeTab = tab.name"
                        href="#"
                    >
                        {{ tab.label }}
                    </a>
                    </li>
                </ul>

                <!-- Tab Content -->
                <div class="tab-content p-3 border rounded bg-light">
                   
                    <div v-if="activeTab === 'videos'">
                        <!-- Videos content -->
                        <div class="video-container">
                            
                            <div class="video-upload-wrapper">
                            <!-- Upload Button -->
                                <div v-if="previewVideo" class="video-actions mt-2 text-center">
                                    <button class="btn btn-success" @click="uploadVideo" v-if="!vloading">
                                    <i class="fa fa-upload"></i> Upload
                                    </button>
                                    <button class="btn btn-success" type="button" disabled v-else>
                                    <i class="fas fa-spinner fa-spin"></i> Uploading...
                                    </button>
                                </div>
                            </div>

                            <div class="col-sm-12">
                                <div class="row">
                                   
                                    <p>&nbsp;</p>
                                    <div
                                    class="col-sm-3 mb-3"
                                    v-for="(vid, index) in escort_video.videos" :key="index">
                                    <div style="position: relative; border-radius: 10px; overflow: hidden; cursor: pointer;">
                                        <!-- Video Element -->
                                        <video
                                        :src="vid.file"
                                        controls
                                        style="width: 100%; height: 250px; object-fit: cover; border-radius: 10px;"
                                        >
                                        Your browser does not support the video tag.
                                        </video>

                                        <!-- Optional: Play Icon Overlay if you want it only on hover -->
                                        <!--
                                        <div class="play-overlay" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;
                                            display: flex; align-items: center; justify-content: center; background: rgba(0,0,0,0.3);">
                                        <i class="fa fa-play-circle" style="font-size: 40px; color: white;"></i>
                                        </div>
                                        -->

                                        <!-- Remove Button -->
                                        <div class="mt-2 text-center">
                                            <small>{{ vid.description }}</small><br/>
                                        <button
                                            class="btn btn-sm btn-outline-danger"
                                            @click="removeVideo(video)"
                                            title="Remove video"
                                        >
                                            <i class="fa fa-trash"></i> Remove
                                        </button>
                                        </div>
                                    </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
        </div>

        <div v-if="splashScreen">
            <transition name="modal" >
                <div class="modal-mask">
                    <div class="modal-wrapper col-md-4" style="margin:auto">
                        <!-- <div class="modal-dialog modal-xl"> -->
                            <div class="profile-view2">
                                <hr style="color:#3E3D3D; margin-top:-20px">
                                <span class="profile-bio2">
                                     <p style="font-size:x-large">
                                        <i class="fas fa-spinner"></i> Processing...
                                     </p>
                                </span>
                            </div>
                        <!-- </div> -->
                    </div>
                </div>
            </transition>
        </div> 
        <div class="loader" v-if="pageLoader">
            <span class="dot"></span> 
            <span class="dot"></span>
            <span class="dot"></span>
        </div>

        <v-dialog v-model="showImageDialog" max-width="800px">
        <v-card>
            <v-img :src="selectedImage" aspect-ratio="1.5" contain></v-img>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="pink darken-1" @click="showImageDialog = false">Close</v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>

        <!-- On Tour Modal -->
        <div id="ontour" class="modal-window">
            <div class="modal-container">
                <div class="modal-top">
                    <a href="#" title="Close" class="modal-close-mobile"> <i class="fa fa-times-circle" aria-hidden="true"></i></a>
                    <br>
                </div>
                <div class="modal-body">
                    <div >
                    
                        <h2 class="mt-3">
                            ON TOUR
                        </h2>
                        <p class="welcome mb-2">Where are you travelling to?</p>
                        
                        <div >
                            <label class="mb-1">From </label>
                            <v-autocomplete
                            class="login-modal-box"
                            v-model="from"
                            :items="options"
                            label="Select your current location"
                            ></v-autocomplete>
                        </div>
                        <div class=" mt-2">
                            <label class="mb-1">To</label>
                            <input type="text"  class="login-modal-box" v-model="to" placeholder="e.g Maitama, Abuja">
                        </div>
                        <div class=" mt-2">
                            <label class="mb-1">Travel Date</label>
                            <input type="date"  class="login-modal-box" v-model="travel_date">
                        </div>

                        <div class=" mt-2">
                            <button class="btn-login" @click="save_tour()" v-if="!tloading"> Save </button>
                            <button class="btn-login" type="button" disabled v-if="tloading">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Saving...
                            </button>
                        </div>
                    </div>
                </div>
                <div class="modal-bottom">
                    <div>
                        <a href="#" title="Close" class="modal-close"> <i class="fa fa-times-circle" aria-hidden="true"></i></a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import swal from 'sweetalert2';
export default {

    components: {    
    },
    
    data() {
    return {
        pageLoader: false,
        image_path: '',
        splashScreen: false,
        selectedImage: null,
        showImageDialog: false,
        profile: true,
        edit_profile: false,
        btn_success: false,
        btn_success2: false,
        previewLoading: false,
        previewImage:'',
        previewVideo:'',
        myprofile: '',
        age: '',
        fullname: '',
        firstname:'',
        middlename: '',
        lastname: '',
        email: '',
        phone: '',
        day: '',
        month: '',
        year: '',
        gender: '',
        location: '',
        state: '',
        from:'',
        to:'',
        travel_date: '',
        aboutyou: '',
        occupation: '',
        religion: '',
        sexuality: '',
        relationship_goal: '',
        loading: false,
        loading2: false,
        tloading: false,
        cloading: false,
        rloading: false,
        vloading: false,
        userphoto: '',
        country: '',
        profile_pictures:[],
        options: [],
        transport: '',
        activeTab: 'videos',
        
        pricingOptions: [
        { value: "negotiable", text: "Negotiable" },
        { value: "5k", text: "₦5,000" },
        { value: "10k", text: "₦10,000" },
        { value: "15k", text: "₦15,000" },
        { value: "premium", text: "₦20,000 and above" },
        ],

        options3: [

            {
                value: "Gay",
                text: "Gay",
            },
            {
                value: "Lesbian",
                text: "Lesbian",
            },
            {
                value: "Bisexual",
                text: "Bisexual",
            },
            {
                value: "Straight",
                text: "Straight",
            },
            {
                value: "I'd prefer not to say",
                text: "I'd prefer not to say",
            },
        ],
        options4: [
        {
            value: "My fare must be covered",
            text: "My fare must be covered",
        },
        {
            value: "I'll find my own way there",
            text: "I'll find my own way there",
        },
        {
            value: "I prefer to be picked up",
            text: "I prefer to be picked up",
        },
        {
            value: "I'll need return fare too",
            text: "I'll need return fare too",
        },
        {
            value: "Only available within my area",
            text: "Only available within my area",
        }
        ],

        options5: [

            {
                value: "3",
                text: "3 Months",
            },
            {
                value: "6",
                text: "6 Months",
            },
            {
                value: "12",
                text: "One Year",
            },
            
        ],
        photos: '',
        profile_photo: '',
        userid: '',
        escort_data: '',
        escort_info:[],
        escort_tour: [],
        escortid: '',
        yearsList: [],

        personality: [],
        interests: [],
        turnOns: [],
        turnOffs: [],
        smokes: '',
        drinks: '',
        tattoosOrPiercings: '',
        groupBooking: '',
        videoChatAvailable: '',
        transportPreference: [],
        build: '',
        bustSize: '',
        ethnicity: '',
        education: '',
        occupations: '',
        weight: '',
        height: '',
        rates: [],
        countLikes: 0,
        countFollowers: 0,
        listFollowers: [],
        profilePictureFile: '',
        profileVideoFile: '',
        escort_video: [],
        services: [],
        video_description: ''

        };
    },

beforeMount(){
    this.userid = this.$route.params.escortid;
    this.listEscortVideos(this.userid)
    this.listEscortProfile(this.userid)
    this.getStates()
    this.checkUserProfilePhotoAndPhoto(); 
},

mounted(){
    this.listMyProfile(this.userid);
    this.generateYears();
    this.fetch_preferences();
    this.fetchRates();
},

methods: {
    
    generateYears() {
      const start = 1940;
      const end = new Date().getFullYear();
      for (let i = start; i <= end; i++) {
        this.yearsList.push(i);
      }
    },

    backProfile() {
        this.profile = true,
        this.edit_profile = false
    },

    async pickFile() {
        let input = this.$refs.fileInput;
        let file = input.files;
        
        if (file && file[0]) {
            let reader = new FileReader();
            
            reader.onload = (e) => {
            this.previewImage = e.target.result; // Show image preview
            this.profilePictureFile = file[0];   // Correct assignment of File object
            };

            reader.readAsDataURL(file[0]);

            this.$emit("input", file[0]);  // Optional: for parent components
            this.btn_success = true;       // Enable save button or mark success
        }
    },

    async pickVideoFile() {
        let input = this.$refs.videoInput;
        let file = input.files;
        
        if (file && file[0]) {

            //this.previewLoading = true; // Start loading

            let reader = new FileReader();
            
            reader.onload = (e) => {
            this.previewVideo = e.target.result; // Show image preview
            this.profileVideoFile = file[0];   // Correct assignment of File object
            };
           
            reader.readAsDataURL(file[0]);

            this.$emit("input", file[0]);  // Optional: for parent components
            
        }
    },
    async uploadFile() {
        try {

            this.loading = true;

            // Build FormData for submission
            const formData = new FormData();
            formData.append('escortid', this.escortid);

            // Add image file if selected
            if (this.profilePictureFile) {
                formData.append('gallery_image', this.profilePictureFile);
            }

            // Send request
            const response = await this.$http.post('/upload-galleries', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            this.loading = false;

            if (response.data.success) {
                swal.fire({
                    icon: 'success',
                    width: 450,
                    text: response.data.message,
                }).then(() => {
                    window.location.reload(); 
                });
                this.listEscortProfile(this.userid)
            } else {
                swal.fire({
                    icon: 'warning',
                    width: 450,
                    text: response.data.message,
                });
            }
        } catch (err) {
            console.error(err);
            this.loading = false;
            swal.fire({
            icon: 'error',
            title: 'Server Error',
            text: err.response ? err.response.data.message : err.message,
            });
        }
    },
    async uploadVideo() {
        try {

            if (!this.description) {
                swal.fire({
                    icon: 'warning',
                    width: 450,
                    text: 'Please provide image description',
                });
                return;
            }
            if (!this.profileVideoFile) {
                swal.fire({
                    icon: 'warning',
                    width: 450,
                    text: 'Please select a video',
                });
                return;
            }
            this.vloading = true;

            // Build FormData for submission
            const formData = new FormData();
            formData.append('escortid', this.escortid);
            formData.append('video_description', this.video_description);

            // Add image file if selected
            if (this.profileVideoFile) {
                formData.append('gallery_video', this.profileVideoFile);
            }

            // Send request
            const response = await this.$http.post('/upload-videos', formData, {
                headers: { 'Content-Type': 'multipart/form-data' },
            });

            this.vloading = false;

            if (response.data.success) {
                swal.fire({
                    icon: 'success',
                    width: 450,
                    text: response.data.message,
                }).then(() => {
                    window.location.reload(); 
                });
                this.listEscortProfile(this.userid)
            } else {
                swal.fire({
                    icon: 'warning',
                    width: 450,
                    text: response.data.message,
                });
            }
        } catch (err) {
            console.error(err);
            this.loading = false;
            swal.fire({
            icon: 'error',
            title: 'Server Error',
            text: err.response ? err.response.data.message : err.message,
            });
        }
    },
    async listMyProfile(userid){
         try{
            this.pageLoader = true
            const response = await this.$http.post('/list-profile',
            { user_id: userid},
            {
            headers: { 
                //"x-api-key": `${process.env.VUE_APP_API_KEY}`,
                'Content-Type': 'application/json' 
            }
            }    
            )
            this.escort_data = response.data.data[0];
            this.pageLoader = false
        
            }catch (err) {
                console.log(err);
            }
    },
    async listEscortProfile(userid){
         try{

            const response = await this.$http.post('/list-escort-byid',{ user_id: userid} )
            this.escort_info = response.data.data;
            this.escortid = this.escort_info.id

            this.listEscortTour(this.escortid)
            this.getFollowers(this.escort_info.id)
            this.getLikes(this.escort_info.id)
           


            }catch (err) {
                console.log(err);
            }
    },
    async listEscortVideos(userid){
         try{

            const response = await this.$http.post('/list-escort-videos',{ user_id: userid} )
            this.escort_video = response.data.data;

            }catch (err) {
                console.log(err);
            }
    },
    async editProfile(userid){
        this.$router.push("/update-profile/"+userid +'/'+this.escort_data.username)
    },
    async getStates() {
    try{
        const response = await this.$http.get('/state/fetch', {
            headers: { 
                "x-api-key": `${process.env.VUE_APP_API_KEY}`,
                'Content-Type': 'application/json' 
               },
        })

        response.data.states.forEach((el) => {
        this.options.push({
          value: el.state,
          text: el.state,
        });

      });
               
        }catch (err) {
            console.log(err);
        }
    },
    async remove(filepath) {
        let conf = confirm("           Are you sure about this?")
        if(conf == true) {
            this.splashScreen = true;
            this.response = await this.$http.post('/remove-gallery', {
                filepath: filepath
            });
            this.splashScreen = false;

            if (!this.response.data.success) {
                swal.fire({
                    icon: 'error',
                    width:350,
                    height:3,
                    title: this.response.data.message,
                });
                this.listEscortProfile(this.userid)
                return;
            }else{

                swal.fire({
                    icon: "success",
                    title: this.response.data.message,
                    width:450,
                    height:5,
                });
                this.listEscortProfile(this.userid)
               
                return;
        }
    }
    },

    async removeVideo(filepath) {
        let conf = confirm("           Are you sure about this?")
        if(conf == true) {
            this.splashScreen = true;
            this.response = await this.$http.post('/remove-videos', {
                filepath: filepath
            });
            this.splashScreen = false;

            if (!this.response.data.success) {
                swal.fire({
                    icon: 'error',
                    width:350,
                    height:3,
                    title: this.response.data.message,
                });
                this.listEscortProfile(this.userid)
                return;
            }else{

                swal.fire({
                    icon: "success",
                    title: this.response.data.message,
                    width:450,
                    height:5,
                });
                this.listEscortProfile(this.userid)
               
                return;
        }
    }
    },

    async save_tour(){
        try {

            this.tloading = true;

            // Send request
            const response = await this.$http.post('/create-tour', {
                escortid: this.escortid,
                from: this.from,
                to: this.to,
                travel_date: this.travel_date,
            });

            this.tloading = false;

            if (response.data.success) {
                swal.fire({
                    icon: 'success',
                    width: 450,
                    text: response.data.message,
                }).then(() => {
                    // Hide the modal
                    document.getElementById("ontour").style.display = "none";
                });

            } else {
                swal.fire({
                    icon: 'warning',
                    width: 450,
                    text: response.data.message,
                });
            }
            } catch (err) {
                console.error(err);
                this.loading = false;
                swal.fire({
                icon: 'error',
                title: 'Server Error',
                text: err.response ? err.response.data.message : err.message,
            });
            }
    },

    async listEscortTour(escortid){
         try{

        const response = await this.$http.post('/list-escort-tours',{ escortid: escortid} )
        this.escort_tour = response.data.data;
    
        }catch (err) {
            console.log(err);
        }
    },

    async fetch_preferences() {
    try {

        const response = await this.$http.get(`/get-escort-preferences/${this.userid}`);

        if (response.data.success && response.data.data) {
        const prefs = response.data.data[0];

        this.personality = prefs.personality ? prefs.personality.split(',') : [];
        this.interests = prefs.interests ? prefs.interests.split(',') : [];
        this.turnOns = prefs.turn_ons ? prefs.turn_ons.split(',') : [];
        this.turnOffs = prefs.turn_offs ? prefs.turn_offs.split(',') : [];

        this.smokes = prefs.smokes || '';
        this.drinks = prefs.drinks || '';
        this.tattoosOrPiercings = prefs.tattoos_or_piercings || '';
        this.groupBooking = prefs.group_booking || '';
        this.videoChatAvailable = prefs.video_chat_available || '';
        this.transportPreference = prefs.transport_fare || '';
        this.build = prefs.build,
        this.bustSize = prefs.bustSize,
        this.ethnicity = prefs.ethnicity,
        this.education= prefs.education,
        this.occupations= prefs.occupations,
        this.weight = prefs.weight,
        this.height=prefs.height
        this.services = prefs.services ? prefs.services.split(',') : [];
        }
    } catch (err) {
        console.error(err);
        // swal.fire({
        // icon: 'error',
        // title: 'Error loading preferences',
        // text: err.response ? err.response.data.message : err.message,
        // });
    }
    },

    async create_preferences() {
    try {

        this.tloading = true;

        const payload = {
            escort_id: this.escortid,
            personality: this.personality,               // array
            interests: this.interests,                   // array
            turnOns: this.turnOns,                       // array
            turnOffs: this.turnOffs,                     // array
            smokes: this.smokes,                         // 'Yes' or 'No'
            drinks: this.drinks,                         // 'Yes' or 'No'
            tattoosOrPiercings: this.tattoosOrPiercings, // 'None', 'Tattoos', 'Piercings', 'Both'
            groupBooking: this.groupBooking,             // 'Yes' or 'No'
            videoChatAvailable: this.videoChatAvailable,  // 'Yes' or 'No'
            transportPreference: this.transportPreference,               // array
            build: this.build,
            bustSize: this.bustSize,
            ethnicity: this.ethnicity,
            education: this.education,
            occupations: this.occupations,
            weight: this.weight,
            height: this.height,
            services: this.services
        };

        const response = await this.$http.post('/create-escort-preferences', payload);

        this.tloading = false;

        if (response.data.success) {
        swal.fire({
            icon: 'success',
            width: 450,
            text: response.data.message,
        }).then(() => {
        window.location.reload(); 
    });
        } else {
        swal.fire({
            icon: 'warning',
            width: 450,
            text: response.data.message,
        });
        }

    } catch (err) {
        console.error(err);
        this.tloading = false;
        swal.fire({
        icon: 'error',
        title: 'Server Error',
        text: err.response ? err.response.data.message : err.message,
        });
      }
    },

    addRate() {
    this.rates.push({ duration: '', in_call_price: '', out_call_price: '' });
    },

    async removeRate(index) {
        const rate = this.rates[index];

        // Confirm the rate has been saved (has an ID)
        if (rate.rateid) {
            const confirmDelete = await swal.fire({
            icon: 'warning',
            title: 'Are you sure?',
            text: 'This will permanently delete the rate.',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            });

            if (confirmDelete.isConfirmed) {
            try {
                const response = await this.$http.delete(`/delete-escort-rate/${rate.rateid}`);

                if (response.data.success) {
                this.rates.splice(index, 1); // Remove from UI
                swal.fire({
                    icon: 'success',
                    text: 'Rate deleted successfully.',
                });
                } else {
                swal.fire({
                    icon: 'error',
                    text: response.data.message || 'Failed to delete rate.',
                });
                }
            } catch (err) {
                console.error(err);
                swal.fire({
                icon: 'error',
                title: 'Server Error',
                text: err.response ? err.response.data.message : err.message,
                });
            }
            }
        } else {
            // Not saved in DB yet — just remove locally
            this.rates.splice(index, 1);
        }
    },

    async fetchRates() {
        try {
        const res = await this.$http.get(`/get-escort-rates/${this.userid}`);
        if (res.data.success && res.data.data.length > 0) {
            this.rates = res.data.data;
        } else {
            this.rates = [{ duration: '', inCall: '', outCall: '' }];
        }
        } catch (err) {
        console.error('Failed to fetch rates', err);
        }
    },

    async saveRates() {
        try {
        this.rloading = true;
        const payload = {
            escort_id: this.escortid,
            rates: this.rates,
        };
        const res = await this.$http.post('/create-escort-rates', payload);
        this.rloading = false;

        if (res.data.success) {
            swal.fire({
            icon: 'success',
            width: 450,
            text: res.data.message,
        }).then(() => {
        window.location.reload(); 
    });
        } 
        } catch (err) {
        this.loading = false;
        console.error(err);
        swal.fire({ icon: 'error', title: 'Error', text: err.message });
        }
    },

    async handleChat() { 
        this.$router.push(`/chat/${this.escort_info.user_id}/${this.escort_data.username}`)
    },

    async getFollowers(userid) {
    try {

        const response = await this.$http.get(`/escort-followers/${userid}`, {});
        this.countFollowers = response.data.data.length;
        this.listFollowers = response.data.data;
      
    } catch (err) {
      console.error(err);
      swal.fire({
        icon: 'error',
        title: 'Error',
        text: err.response?.data?.message || 'Server error occurred.',
        width: 400
      });
    }
    },

    async getLikes(userid) {
    try {

        const response = await this.$http.get(`/escort-likes/${userid}`, {});
        this.countLikes = response.data.data.length
      
    } catch (err) {
      console.error(err);
      swal.fire({
        icon: 'error',
        title: 'Error',
        text: err.response?.data?.message || 'Server error occurred.',
        width: 400
      });
    }
    },
}
}

</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans&family=Raleway&display=swap');

.loading-overlay {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: transparent;
  position: absolute;
  z-index: 10;
}

.image-upload-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1rem;
}

.video-upload-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 1rem;
}

.likes-followers{
    margin-top: 10px;
    display: flex;
    flex-direction: row;
    justify-content: center;

    h4{
        font-family: 'DM Sans';
        font-style: normal;
        font-weight: 500;
        font-size: 11px;
        color: #FFFFFF;
    }
}

.image-preview {
  width: 160px;
  height: 160px;
  background-color: #f0f0f0;
  background-size: cover;
  background-position: center;
  border: 2px dashed #ccc;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: border-color 0.3s ease;
}

.image-preview:hover {
  border-color: #D33E74;
}

.video-preview {
  width: 160px;
  height: 160px;
  background-color: #f0f0f0;
  background-size: cover;
  background-position: center;
  border: 2px dashed #ccc;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: border-color 0.3s ease;
}

.video-preview:hover {
  border-color: #D33E74;
}

.upload-placeholder {
  text-align: center;
  color: #888;
  font-size: 14px;
}

.video-placeholder {
  text-align: center;
  color: #888;
  font-size: 14px;
}

.file-hidden {
  display: none;
}

.video-hidden {
  display: none;
}

.upload-actions {
  margin-top: 10px;
}

.video-actions {
  margin-top: 10px;
}

.rates {
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 600;
    margin: 20px 0;
}
@media screen and (max-width: 768px) {

    .rate-row {
        display: flex;
        flex-direction: column;
    }
    .rate-inputs {
        display: flex;
        flex-direction: column;
    }
}
.label-title {
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 10px;
  display: block;
}
.rate-row {
  display: flex;
  gap: 10px;
  margin-bottom: 10px;
}
.rate-inputs {
  display: flex;
  gap: 10px;
  flex: 1;
}
.input-textx {
  padding: 8px;
  width: 100%;
}
.btn-add, .btn-remove, .btn-user-login {
    margin-top: 10px;
    color: #D33E74;
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 600;
    font-size: 13px;
}

.label-title{
    font-family: 'Raleway';
    font-weight: bold;
    font-size: 14px;
    color: #fff;
    background: #0A070F;
    border-radius: 10px;
    padding: 0.3rem;
}

.checkbox-group {
  margin-bottom: 15px;
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}
.checkbox-group label {
  font-size: 14px;
  color: #D33E74;
}
.btn-user-login {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px 52px;
    background: #D33E74;
    border-radius: 50px;
    color: #fff;
    width: 100%;
    height: 50px;
}
.label {
  display: block;
  font-weight: bold;
  margin-top: 10px;
  margin-bottom: 5px;
}

.bio-tab{
    margin-top: 20px;
}
.nav-link{
    color: #D33E74;
}
 .nav-tabs .nav-link {
    cursor: pointer;
    font-family: 'Raleway';
    font-style: normal;
    font-size: 13px;
 }

.nav-tabs .nav-link.active {
    background-color: #D33E74;
    color: white;
    border-radius: 0.25rem;
    font-family: 'Raleway';
    font-style: normal;
    font-size: 13px;
}

.loader{
    width:100%;
    height:300px;
    display:flex;
    align-items:center;
    justify-content:center;
    gap:20px;
    margin-top:-300px
  }
  .mobile-line{
    display: flex;
    color: #767475;
    width: 90%;
}
  .dot{
    height:40px;
    width:40px;
    border-radius:50%;
  }

.tab-content{
    width: 100%;
    div p {
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 600;
        font-size: 10px;
    }
}
  .dot:nth-child(1){
    background-color:red;
    animation: jump 0.6s 0.5s ease-in infinite
  }
  .dot:nth-child(2){
    background-color:blue;
    animation: jump 0.6s 0.7s ease-in infinite
  }
  .dot:nth-child(3){
    background-color:orange;
    animation: jump 0.6s 0.9s ease-in infinite
  }
  
  
  @keyframes jump{
    0%{
      transform: translate3D(0,0,0);
      opacity: 0;
    }
      50%{
      transform: translate3D(0,-15px,0);
        opacity: 0.5;
    }
      100%{
      transform: translate3D(0,0,0);
        opacity: 1;
    }
  }

  .modal-window {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    visibility: hidden;
    opacity: 0;
    pointer-events: none;
    transition: all 0.3s;
    &:target {
      visibility: visible;
      opacity: 1;
      pointer-events: auto;
    }
    & > div {
      width: 580px;
      height: 450px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      padding: 2em;
      border: 1px solid #2F2F2F;
      backdrop-filter: blur(13px);
      background: url(../assets/modal_bg.png) no-repeat fixed center, #0A070F;
      box-sizing: border-box;
    }
    header {
      font-weight: bold;
    }
    h1 {
      font-size: 150%;
      margin: 0 0 15px;
    }
    h2 {
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 23px;
        text-align: center;
        color: #FFFFFF;
    }
    .welcome {
        margin-top: 8px;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 23px;
        text-align: center;
        color: #FFFFFF;
    }
    label {
        text-align: left;
        color: #fff;
        font-size: 12px;
        margin-left:15px;
        margin-bottom: -6px;
    }
    span {
        margin-bottom: 20px;
    }

}
.modal-container{
    display: flex;
    flex-direction: row;
}
.login-modal-box {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 100%;
    height: 45px;
    background: #2D2D2D;
    border: 0 solid;
    border-radius: 50px;
    font-size: 12px;
    color: #fff !important;
  }

  .btn-login {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    gap: 10px;
    background: #D33E74;
    border-radius: 82px;
    margin-top: 8px;
    color: #fff;
    width: 100%;
    
}
  .modal-close {
    color: #fff;
    line-height: 50px;
    font-size: 140%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 2;
    width: 70px;
    text-decoration: none;
    &:hover {
      color: black;
    }
  }
  .modal-close-mobile {
    color: #fff;
    line-height: 50px;
    font-size: 140%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 2;
    width: 70px;
    text-decoration: none;
    &:hover {
      color: black;
    }
    display: none;
  }
  .modal-window {
    & > div {
        border-radius: 63px;
    }
  }
  .modal-logo {
    text-align: center;
    margin-top: -10px;
  }
  .modal-logo > img {
    width: 100px;
    
}
h2 {
   
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    font-size: 10px;
    line-height: 42px;
    text-align: center;
    color: #FFFFFF;
    line-height: 190%;
    margin-top: 0px;

}

@media screen and (max-width: 768px) {

.modal-window {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 999;
    visibility: hidden;
    opacity: 0;
    pointer-events: none;
    transition: all 0.3s;
    &:target {
      visibility: visible;
      opacity: 1;
      pointer-events: auto;
    }
    & > div {
      width: 90%;
      height: 490px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      padding: 2em;
      border: 1px solid #2F2F2F;
      backdrop-filter: blur(13px);
      box-sizing: border-box;
    }
    header {
      font-weight: bold;
    }
    h1 {
      font-size: 150%;
      margin: 0 0 15px;
    }
  }
  .modal-container{
    display: flex;
    flex-direction: row;
}
  .modal-close {
    color: #fff;
    line-height: 50px;
    font-size: 140%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 2;
    width: 70px;
    text-decoration: none;
    &:hover {
      color: black;
    }
    display: none;
  }
  .modal-close-mobile {
    color: #fff;
    line-height: 50px;
    font-size: 140%;
    position: absolute;
    right: 0;
    text-align: center;
    top: 2;
    width: 70px;
    text-decoration: none;
    &:hover {
      color: black;
    }
    display: block;
  }
  .modal-window {
    & > div {
        border-radius: 63px;
    }
  }
  .modal-logo > img {
    width: 90px;
    text-align: center;
}
h2 {
   
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    font-size: 17px;
    line-height: 42px;
    text-align: center;
    color: #FFFFFF;
    line-height: 190%;
    margin-top: 20px;

}

.terms {
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 19px;
    text-align: center;
    color: #FFFFFF;

    span {
        color: #D33E74;
    }
}

}
.modal-mask {
    // position: fixed;
     z-index: 9998;
     top: 0;
     left: 0;
     //width: 100%;
     height: 100%;
     background: rgba(0, 0, 0, .5) !important;
     display: table;
     transition: opacity .3s ease;
     & > div {
         //width: 100%;
         height: 120px;
         position: absolute;
         top: 50%;
         left: 50%;
         transform: translate(-50%, -50%);
         //padding: 2em;
         border: 1px solid #2F2F2F;
         //backdrop-filter: blur(13px);
         background: #19181B;
         border-radius: 20px;
         box-sizing: border-box;
       }
       .profile-view2{
         box-sizing: border-box;
         border-radius: 20px;
         //position:relative;
         width: 100%;
         height: 100%;
         background: #111112;
         .profile-photo2{
             width: 100%;
             height: auto;
             background: linear-gradient(180deg, rgba(0, 0, 0, 0.25) 59.17%, rgba(0, 0, 0, 0.5) 80.14%), #2F2F2F;
         }
     }


     .profile-interest2{
         
         h3 {
             width: auto;
             height: 26px;
             font-family: 'DM Sans';
             font-style: normal;
             font-weight: 700;
             font-size: 20px;
             line-height: 26px;
             text-align: left;
             color: #FFFFFF;
             margin:20px;
         }
         .interests2{
             box-sizing: border-box;
             display: flex;
             flex-direction: row;
             justify-content: center;
             align-items: center;
             padding: 2px 8px;
             width: auto;
             height: 29px;
             background: #111112;
             border: 1px solid #D33E74;
             border-radius: 50px;
             color: #767475;
             font-size: 10px;
             margin: 4px;
 
         }
 
         .interests-info2 {
             display: flex;
             flex-direction: row;
             //padding: 0rem 3rem 5rem 1rem;
         }
     }
     .profile-relationship-goal2 {
         margin-top: -150px !important;
         h3 {
             width: auto;
             height: 26px;
             font-family: 'DM Sans';
             font-style: normal;
             font-weight: 700;
             font-size: 20px;
             line-height: 26px;
             text-align: left;
             color: #FFFFFF;
             margin:20px;
         }
         .relationship-goal2 {
             display: flex;
             flex-direction: row;
             padding: 2px;
             width: 70%;
             height: auto;
             background: rgba(255, 214, 0, 0.1);
             border-radius: 61px;
             color: #FFD600;
             font-size: 10px;
             margin: 20px;
             text-align: left;
         }
 
     }
     .btn-unmatch-report2 {
         display: flex;
         flex-direction: row;
         align-items: center;
         .btn-unmatch2 {
             box-sizing: border-box;
             display: flex;
             flex-direction: row;
             justify-content: center;
             align-items: center;
             padding: 10px;
             width: 55%;
             height: 30px;
             background: #111112;
             border: 1px solid #D33E74;
             border-radius: 82px;
             font-family: 'Source Sans 3';
             font-style: normal;
             font-weight: 400;
             font-size: 13px;
             line-height: 28px;
             color: #D33E74;
             margin: 20px;
             cursor: pointer;
         }
         .btn-unmatch3 {
             box-sizing: border-box;
             display: flex;
             flex-direction: row;
             justify-content: center;
             align-items: center;
             padding: 10px;
             width: 55%;
             height: 30px;
             background: #111112;
             border: 1px solid #D33E74;
             border-radius: 82px;
             font-family: 'Source Sans 3';
             font-style: normal;
             font-weight: 400;
             font-size: 13px;
             line-height: 28px;
             color: #b1acae;
             margin: 20px;
             cursor: pointer;
         }
         .btn-report2 {
             display: flex;
             flex-direction: row;
             justify-content: center;
             align-items: center;
             padding: 10px;
             width: 55%;
             height: 30px;
             background: #2D2D2D;
             border-radius: 82px;
             font-family: 'Source Sans 3';
             font-style: normal;
             font-weight: 400;
             font-size: 13px;
             line-height: 28px;
             color: #767475;
             margin-right: 10px;
             cursor: pointer;
         }
     }
}
.content-fluid {
    background: transparent;
}
.container {
    margin-top: 80px;
    width: 100%;
    min-height: 80vh;
}
.profile-container{
    display: flex;
    flex-direction: row;
}
.large-profile-pic {
  width: 140px;
  height: 140px;
  border-radius: 50%;
}

 .profile-image {
    display: flex;
    flex-direction: row;
    width: 100%;

    .img-profile {
        width: 60%;
        height: 60%;
        margin:2px;
        border-radius: 100px;
    }

    .profile-info {
        display: flex;
        flex-direction: column;
        justify-content: left;

        h3 {
            font-family: 'Raleway';
            font-style: normal;
            font-weight: bold;
            font-size: 25px;
            text-align: left;
            color: #FFFFFF;
        }
        p {
            font-family: 'DM Sans';
            font-style: normal;
            font-weight: 500;
            font-size: 15px;
            text-align: left;
            color: #FFFFFF;
        }        
    }
    .bio-trials{
        display: flex;
        flex-direction: row;
        justify-content: left;
        align-items: center;
        color: #FFFFFF;
        font-family: 'Raleway';
        font-weight: 650;
    
        .btn-trial{
            background: #FFD600;
            border: solid 0;
            color: #000;
            border-radius: 10px;
            font-size: 11px;
            padding: 0.4rem;
        }
    }
    .bio-buttons{
        display: flex;
        flex-direction: row;
        justify-content: left;
        align-items: center;
        font-family: 'Raleway';
        font-weight: 650;

        .btn-tour{
            background: #D33E74;
            color: #000;
            border: solid 0;
            border-radius: 10px;
            font-size: 11px;
            padding: 0.4rem;
        }
        .btn-boost{
            background: green;
            border: solid 0;
            border-radius: 10px;
            font-size: 11px;
            padding: 0.4rem;
            color: #ddd;
        }
        .btn-activate{
            background: transparent;
            border: solid 0;
            font-size: 11px;
            a{
                color: green;
                text-decoration: none;
            }
        }

        .btn-chat {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 10px 8px;
        width: 100px;
        height: 30px;
        background: #007BFF;
        border: 0px solid;
        border-radius: 50px;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 21px;
        text-align: center;
        color: #FFFFFF;
    }
        
    }
    .select-profile{
        background: linear-gradient(180deg, rgba(0, 0, 0, 0.08) 68.1%, rgba(0, 0, 0, 0.5) 78.43%), #2F2F2F;
        border: 3px solid #D33E74;
        border-radius: 50%;
        width: 145px;
        height: 145px;
        display: block;
        margin-top: 15px;
        margin-bottom: 25px;
    }
 }
 .profile-picture{
    display: flex;
    flex-direction: row;
    justify-content: left;
    margin-right: 10px;
 }
.profile-edit-button{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

    .btn-edit {
        box-sizing: border-box;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 10px 18px;
        width: 120px;
        height: 40px;
        background: #D33E74;
        border: 0.5px solid #D33E74;
        border-radius: 50px;
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 21px;
        text-align: center;
        color: #FFFFFF;
    }
}

.photo {
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    font-size: 16px;
    line-height: 28px;
    text-align: left;
    color: #FFFFFF;
    margin-left: -45px;
    margin-top: 10px;

}

 .edit-profile-top {
    width: 100%;
 }
 .user-interests{
    display: flex;
    flex-wrap: wrap;
    gap: 10px; /* spacing between buttons */
 }

 .btn-chips {
  padding: 8px 16px;
  border: none;
  background-color: #eee;
  border-radius: 20px;
  cursor: pointer;
  font-family: 'DM Sans', sans-serif;
  transition: background-color 0.3s;
}

.btn-chips:hover {
  background-color: #ddd;
}

 .edit-profile {
    color: #FFFFFF;
    font-size: 12px;
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    line-height: 28px;
    //text-align: center;
    color: #FFFFFF;
    cursor: pointer;
 }
 .img-profile{
    display: flex;
    flex-direction: row;
    justify-content: center;
 }
 .img-profile-edit{
    margin-top: 50px;
    margin-bottom: 50px;
    text-align: center;
 }
 .img-profile2 {
        width: 120px;
        height: 120px;
        background: url("../assets/no_image.png");
        background-size: cover;
        padding-bottom: 0rem;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        cursor: pointer;
        border-radius: 100px;
        //background: #D9D9D9;
    }
 .profile-content{
    display: flex;
    flex-direction: row;
    justify-content: center;
 }
 .column1{
    width: 400px;
    margin: 10px;
 }
 .button-container{
    display: flex;
    flex-direction: row;
    justify-content: center;
 }
 .label{
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 13px;
    line-height: 26px;
    text-align: left;
    color: #FFFFFF;
    margin-left: 10px;
 }
 .input-textx {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 100%;
    height: 45px;
    background: #2D2D2D;
    border: 0px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
    color: #fff !important;
 }
 .input-text {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 350px;
    height: 45px;
    background: #2D2D2D;
    border: 0.5px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
    color: #fff !important;
 }

 .input-text-state {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 350px;
    height: 45px;
    background: #2D2D2D;
    border: 0.5px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
    color: #fff !important;
 }
 .birthday{
    display: flex;
    flex-direction: row;
 }
 .input-select {
    box-sizing: border-box;
    align-items: center;
    padding: 10px 40px;
    width: 114px;
    height: 55px;
    background: #2D2D2D;
    border: 0px solid #FFFFFF;
    border-radius: 50px;
    color: #767475;
    font-size: 12px;
    margin: 2px;
}
.rel-goal{
    color:#D33E74;
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
}
.btn-save {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    width: 400px;
    height: 45px;
    background: #D33E74;
    border-radius: 82px;
    font-family: 'Source Sans 3';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 28px;
    color: #FFFFFF;
    margin-top: 15px;
    margin-bottom: 40px;
}

.btn-chips {
    box-sizing: border-box;
    justify-content: center;
    align-items: center;
    padding: 4px 10px;
    width: auto;
    height: 25px;
    margin: 3px;
    margin-bottom: 20px;
    background: #0A070F;
    border: 0.5px solid #D33E74;
    border-radius: 50px;
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 16px;
    text-align: center;
    color: #D33E74;
}      

@media screen and (max-width: 700px) {
    .container{
        margin-top: 100px;
        padding: 0px 0px 0px 0px !important;
    }
    .profile-container{
        display: flex;
        flex-direction: column;
 
    }
    .profile-image {
        display: flex;
        flex-direction: column;
        align-items: center;

        .img-profile {
            width: 30%;
            height: 30%;

        }
        .profile-info {
            padding: 0 0 0 0px;
            h3 {
                font-family: 'Raleway';
                font-style: normal;
                font-weight: bold;
                font-size: 25px;
                line-height: 20px;
                text-align: center;
                color: #FFFFFF;
            }
            p {
                font-family: 'DM Sans';
                font-style: normal;
                font-weight: 500;
                font-size: 14px;
                line-height: 20px;
                text-align: center;
                color: #FFFFFF;
            }
          
        }
        .select-profile{
            width: 145px;
            height: 145px;
        }
     }
    .profile-edit-button{
        margin-top: 10px;
        margin-bottom: 20px;
    
        .btn-edit {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px 18px;
            width: 100px;
            height: 35px;
            background: #D33E74;
            border: 0.5px solid #D33E74;
            border-radius: 50px;
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 500;
            font-size: 10px;
            line-height: 21px;
            text-align: center;
            color: #FFFFFF;
        }
    }
    .mobile-line{
        color: #767475;
        width: 100%;
    }
    .photo {
        font-family: 'Raleway';
        font-style: normal;
        font-weight: 800;
        font-size: 18px;
        line-height: 28px;
        text-align: left;
        color: #FFFFFF;
        margin-left: 55px;
        margin-top: 50px;
    }
    .bio-trials{
        display: flex;
        flex-direction: row;
        justify-content: left;
        align-items: center;
        color: #FFFFFF;
        font-family: 'Raleway';
        font-size: 12px;
        button{
            box-sizing: border-box;
            width: auto;
            height: 20px;
            border-radius: 50px;
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 600;
            font-size: 10px;
            line-height: 21px;
            text-align: center;
            color: #FFFFFF;
        }
        .btn-trial{
            background: #FFD600 !important;
            width: auto !important;
            height: auto !important;
            font-size: 10px !important;
            padding: 4px !important;
            border-radius: 10px !important;
            border: solid 0;
            color: #000;
        }
    }
    .bio-buttons{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;

        .btn-tour{
            background: #D33E74;
            color: #000;
            border: solid 0;
            border-radius: 10px;
            font-size: 10px;
            height: auto;
        }
        .btn-boost{
            background: #000 !important;
            border: solid 0;
            width: 30% !important;
            height: auto !important;
            font-size: 10px !important;
            border-radius: 10px !important;
        }
        .btn-activate{
            background: transparent;
            border: solid 0;
            text-decoration: none;
            color: green;
            width: 40% !important;
            height: auto !important;
            font-size: 10px !important;

        }

        .btn-chat {
            box-sizing: border-box;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            padding: 10px 8px;
            width: 80px;
            height: 35px;
            background: #007BFF;
            border: 0px solid;
            border-radius: 50px;
            font-family: 'Raleway';
            font-style: normal;
            font-weight: 500;
            font-size: 10px;
            line-height: 21px;
            text-align: center;
            color: #FFFFFF;
        }
        
    }
 .edit-profile-top {
  margin-left: 0px;
 }

 .profile-content{
    display: flex;
    flex-direction: column;
 }
 .column1{
    width: 100%;
    margin: 0px;
 }
 .user-interests{
   
 }
 .edit-profile {
    color: #FFFFFF;
    font-size: 12px;
    font-family: 'Raleway';
    font-style: normal;
    font-weight: 800;
    line-height: 28px;
    //text-align: center;
    color: #FFFFFF;
    cursor: pointer;
 }
 .img-profile-edit{
    margin-top: 50px;
    margin-bottom: 50px;

    .img-profile2 {
        width: 120px;
        height: 120px;
        background: url("../assets/no_image.png");
        background-size: cover;
        padding-bottom: 0rem;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        cursor: pointer;
        border-radius: 100px;

    }
 }
 .label{
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
    line-height: 26px;
    text-align: left;
    color: #FFFFFF;
    margin-left: 10px;
 }
 .input-text {
    box-sizing: border-box;
    padding: 10px 52px;
    width: 100%;
    height: 35px;
    background: #0A070F;
    border: 0.5px solid #FFFFFF;
    border-radius: 50px;
    font-size: 12px;
 }
 .birthday{
    display: flex;
    flex-direction: column;
 }
 .input-select {
    box-sizing: border-box;
    align-items: center;
    padding: 10px 40px;
    width: 100%;
    height: 45px;
    background: #2D2D2D;
    border: 0px solid #FFFFFF;
    border-radius: 50px;
    color: #fff;
    font-size: 12px;
    margin: 2px;
}
.rel-goal{
    color:#D33E74;
    font-family: 'DM Sans';
    font-style: normal;
    font-weight: 500;
    font-size: 10px;
   
}
.btn-save {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    width: 100%;
    height: 45px;
    background: #D33E74;
    border-radius: 82px;
    font-family: 'Source Sans 3';
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 28px;
    color: #FFFFFF;
    margin-top: 15px;
}

}

</style>